import { useState } from "react";

export function useFileInput(validationFunction) {
  const [file, setFile] = useState(null);
  const [didEdit, setDidEdit] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setDidEdit(true);

    if (validationFunction) {
      const validationResult = validationFunction(selectedFile);
      setError(validationResult);
    }
  };

  const handleFileDrop = (file) => {
    setFile(file);
    setDidEdit(true);

    if (validationFunction) {
      const validationResult = validationFunction(file);
      setError(validationResult);
    }
  };

  const reset = () => {
    setFile(null);
    setDidEdit(false);
    setError("");
  };

  const isValid = validationFunction ? validationFunction(file) === "" : true;

  return {
    file,
    setFile,
    handleFileChange,
    handleFileDrop, 
    hasError: didEdit && !isValid,
    error: didEdit ? error : "",
    reset,
  };
}
